import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={17.187}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 46420 69414"
    {...props}
  >
    <path
      d="M46187 17471 32825 6767c-223-179-537-182-763-8l-2578 1987c-16-141-66-279-156-401L23251 323c-293-387-858-433-1210-98L254 20925c-247 235-322 601-186 914l14466 33425c44 102 68 212 68 324v6878c0 121 28 237 76 340H2649v6608h28601v-6608H19221c48-103 76-219 76-340v-7851c0-111-23-222-67-324L5681 22984c-136-313-63-677 186-914L21468 7245c353-334 917-288 1211 99l2905 3836c101 134 235 226 382 276l-1751 1350c-225 173-302 479-186 739l6945 15649c162 365 624 483 940 239l7133-5496 7132-5496c316-244 320-720 8-970z"
      style={{
        fill: "#231f20",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
